import styled from "styled-components";

export const TabContent = styled.div`
    padding: 0 10px;

    .ant-list-item-meta {
        align-items: center;
    }
`;